import * as actions from 'redux/actions/billing.actions'

const initialState = {
  loading: false,
  changing: false,
  success: false,
  plan: null,
  currencyCode: null,
  addons: null,
  invoices: null,
  errors: []
}

const billingReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.changePlan.type:
      return {
        ...state,
        changing: true,
        success: false,
        errors: []
      }
    case actions.changePlanFailure.type:
      return {
        ...state,
        errors: payload.errors,
        changing: false,
        success: false,
        loading: false
      }
    case actions.changePlanSuccess.type:
      return {
        ...state,
        changing: false,
        loading: false,
        success: true
      }
    case actions.loadInvoicesSuccess.type:
      return {
        ...state,
        invoices: payload.invoices
      }
    case actions.loadInvoicesFailure.type:
      return {
        ...state,
        invoices: []
      }
    default:
      return state
  }
}
export default billingReducer
